// Single canonical Echo bootstrap (sets window.Echo if not already present).
import './echo';

function userStatusComponent(userId, initialOnline) {
    return {
        userId: userId,
        online: initialOnline,
        lastSeen: null,
        
        init() {
            console.log('🚀 Avatar component initialized for user:', this.userId);
            
            // Store reference to avoid scope issues
            const component = this;
            
            // Wait for Echo to be available and properly initialized
            const initializeEcho = () => {
                try {
                    if (window.Echo && typeof window.Echo.channel === 'function') {
                        console.log('✅ Echo is available, setting up listeners');
                        
                        // Listen to both channels for compatibility
                        window.Echo.channel('user-status')
                            .listen('UserOnlineStatusChanged', (e) => {
                                this.handleStatusChange(e);
                            });
                            
                        window.Echo.channel('online-users')
                            .listen('UserOnlineStatusChanged', (e) => {
                                this.handleStatusChange(e);
                            });
                    } else {
                        console.log('⏳ Echo not ready yet, retrying in 100ms...');
                        setTimeout(initializeEcho, 100);
                    }
                } catch (error) {
                    console.error('❌ Error initializing Echo:', error);
                    // Retry after a longer delay if there's an error
                    setTimeout(initializeEcho, 1000);
                }
            };
            
            // Start the initialization process
            initializeEcho();
        },
        
        handleStatusChange(e) {
            console.log('📡 Received status change:', e);
            
            if (parseInt(e.user_id) === parseInt(this.userId)) {
                console.log('✅ Status update for user', this.userId);
                this.online = Boolean(e.online);
                
                if (!this.online) {
                    this.lastSeen = new Date().toLocaleTimeString();
                }
                
                console.log('Updated online status to:', this.online);
            }
        },
        
        getStatusText() {
            if (this.online) {
                return 'Online';
            } else if (this.lastSeen) {
                return `Last seen: ${this.lastSeen}`;
            } else {
                return 'Offline';
            }
        }
    };
}

// Expose on window for backward compatibility
window.userStatusComponent = userStatusComponent;

// Self-register as Alpine data component
if (window.Alpine) {
    window.Alpine.data('userStatus', (userId, initialOnline) => userStatusComponent(userId, initialOnline));
} else {
    document.addEventListener('alpine:init', () => {
        window.Alpine.data('userStatus', (userId, initialOnline) => userStatusComponent(userId, initialOnline));
    });
}